import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {POSTER_EDITOR_CROP_PANEL_ID} from '@Panels/poster-editor-crop-panel/poster-editor-crop-panel.types';

export const openPosterEditorCropModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_CROP_MODAL,
      panelProps: {
        panelId: POSTER_EDITOR_CROP_PANEL_ID,
      },
    })
  );
};
